// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Dj-p","textarea":"styles_textarea__1TWDE"};